import CustomCard from "../../../../../../../components/CustomCard";
import {CustomCheckbox} from "../../../../../../../components/CustomCheckbox";
import {
    IconCardFillMonitor,
    IconCheckboxChecked,
    IconCheckboxUnchecked, IconCloseChip
} from "../../../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../../../components/CustomTooltip";
import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 05 de 2026
 */

/**
 * Selected device card for the shift access Add/Assigned tabs. Shows the device
 * name with an optional delete action and an optional selection checkbox.
 *
 * @param {Object} props
 * @param {string} props.keyId - Identifier field name used for the item.
 * @param {Object} props.item - Device row ({ [keyId], fullName, checked, disabled }).
 * @param {Function} [props.onDelete] - Callback invoked with the item when removed.
 * @param {Function} [props.handleCheckboxChange] - Selection handler; when set, renders the checkbox.
 * @returns {JSX.Element}
 */
const SelectedDeviceCard = (
    {
        keyId,
        item,
        onDelete,
        handleCheckboxChange
    }
) => {

    return (
        <CustomCard
            classes="w-100"
            classCard="card-border-8px"
            classContent={`background-shades-50`}
        >
            <div className="row">
                <div className={"d-flex justify-content-between p-0"}>
                    { handleCheckboxChange &&
                    <div className={"align-top mr-3"}>
                        <CustomCheckbox
                            id={`cb_sdc_row_${item?.[keyId]}`}
                            checked={item?.checked}
                            onChange={(e) => {
                                handleCheckboxChange({
                                    target: {
                                        [keyId]: item[keyId],
                                        checked: e.target.checked,
                                    },
                                });
                            }}
                            disabled={item?.disabled}
                            icon={<IconCheckboxUnchecked className={"icon-color-general-950"}/>}
                            checkedIcon={<IconCheckboxChecked className={"icon-color-shades-800"}/>}
                            disableRipple={true}
                        />
                    </div>
                    }

                    <div className={"flex-grow-1 minw-0 mr-1 mt-2"}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className={`col-12 p-0`}>
                                <div className='d-flex align-items-center justify-content-start'>
                                    <div><IconCardFillMonitor className="mr-8px mb-1" /></div>
                                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                                        <CustomTooltip
                                            text={item?.fullName}
                                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                    { onDelete &&
                                    <div className={"position-absolute r-0px t-negative-4px"}>
                                        <IconCloseChip
                                            id={`btn_sdc_delete_${item?.[keyId]}`}
                                            className='icon-color-shades-400 icon-hover-shades-950'
                                            onClick={() => onDelete(item)}
                                        />
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CustomCard>
    );
}
export default SelectedDeviceCard
